import React from 'react';
import { useField } from 'formik';
import CustomInput from './Input';
import PropTypes from 'prop-types'

const FormikInput = ({
    placeholder,
    name,
    type,
    maxLength,
    readOnly,
    label,
    containerClassName,
    labelClassname,
    ...props
}) => {
    const [field, meta] = useField({ name, type, placeholder });
    const isError = meta.error && meta.touched;

    return (
        <section className={containerClassName}>
            <label className={`${labelClassname} ${isError ? "text-danger" : ""}`}>{label}</label>
            <CustomInput
                {...field}
                type={type}
                className={isError ? "is-invalid" : ""}
                maxLength={maxLength}
                readOnly={readOnly}
                placeholder={placeholder}
                {...props}
            />
            {isError && <span className="invalid-feedback">{meta.error}</span>}
        </section>
    )
};

FormikInput.propTypes = {
    placeholder: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    maxLength: PropTypes.number,
    readOnly: PropTypes.bool,
    label: PropTypes.string,
    containerClassName: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
}

export default FormikInput;